import React,{useEffect} from 'react'
import featute_icon1 from './images/journyicons/feature_icon01.png'
import featute_icon2 from './images/journyicons/feature_icon02.png'
import featute_icon3 from './images/journyicons/feature_icon03.png'
import featute_icon4 from './images/journyicons/feature_icon04.png'
import { Link } from 'react-router-dom'

import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeStartJourny = () => {

    useEffect(() => {
                AOS.init();
            }, []);


    return (
        <div className='Home_startjourny_section'>
            <div className='container-fluid'>
                <div className='Home_startjourny_section_content' data-aos="fade-up" data-aos-duration="2000">
                    <div className='Home_startjourny_sectionfp'>
                        <p data-aos="fade-up" data-aos-duration="1500">How we begin our journey</p>
                    </div>
                    <h1>Begin your educational path right now!</h1>
                    <p>Take the first step towards a brighter future with Hamo Tech. Our institute is dedicated to empowering learners with the skills and knowledge needed to thrive in today's competitive world. Whether you are starting fresh or enhancing your expertise, our diverse range of courses is designed to meet your goals</p>
                </div>

                <div className='row Home_startjourny_section_gridlist'>
                    <div className='col-lg-3 col-md-6 mt-3' data-aos="fade-up" data-aos-duration="1000">
                        <img src={featute_icon1} className='img-fluid' />
                        <h5>Learn from Professionals</h5>
                        <p>Gain expertise and industry insights from experienced professionals to excel in your career.</p>
                    </div>

                    <div className='col-lg-3 col-md-6 mt-3' data-aos="fade-up" data-aos-duration="1400">
                        <img src={featute_icon2} />
                        <h5>Discover Anything</h5>
                        <p>Unlock endless possibilities and explore a world of knowledge tailored to your ambitions!</p>
                    </div>

                    <div className='col-lg-3 col-md-6 mt-3' data-aos="fade-up" data-aos-duration="1800">
                        <img src={featute_icon3} />
                        <h5>Obtain a Certificate Online</h5>
                        <p>Earn an industry-recognized certificate online and boost your career from the comfort of your home.</p>
                    </div>

                    <div className='col-lg-3 col-md-6 mt-3' data-aos="fade-up" data-aos-duration="2000">
                        <img src={featute_icon4} />
                        <h5>Email Promotion</h5>
                        <p>Boost your outreach with targeted and impactful email campaigns.</p>
                    </div>
                </div>

                <div className='text-center'>
                    <Link to="/contact-us"><button>Apply Now <span><i class="ri-arrow-right-line"></i></span></button></Link>
                </div>
            </div>
        </div>
    )
}

export default HomeStartJourny
